import { render, staticRenderFns } from "./TaskFilterStatus.vue?vue&type=template&id=5c5fb072&scoped=true"
import script from "./TaskFilterStatus.vue?vue&type=script&lang=js"
export * from "./TaskFilterStatus.vue?vue&type=script&lang=js"
import style0 from "./TaskFilterStatus.vue?vue&type=style&index=0&id=5c5fb072&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5fb072",
  null
  
)

export default component.exports